import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const TemplatesIcon = ({ color = '#B5BCBD', size = 24, ...props }) => (
  <svg
    viewBox="0 0 100 100"
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill={color}
      d="M83.5 9.5h-68c-4.412 0-8 3.588-8 8v68c0 4.412 3.588 8 8 8h68c4.41 0 8-3.588 8-8v-68c0-4.412-3.59-8-8-8zm0 32h-36v-24h36v24zm-68-24h24v68h-24v-68zm32 68v-36h36.002l.002 36H47.5z"
    />
  </svg>
);

TemplatesIcon.propTypes = propTypes;

export default TemplatesIcon;
